package org.chiangmeng.qfast.core.domain.models

data class TicketPrintData(
    val shopName: String,
    val ticketNumber: Int,
    val category: String,
    val issueTime: String,
    val waitingCount: Int,
    val customerUrl: String
)
